import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from '@nuxtjs/composition-api'
import AlertLayout from './AlertLayout.vue'
import { ConfirmConfig } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirm',
  setup(__props, { expose }) {

const isOpen = ref(false)
const config = reactive<ConfirmConfig>({
  type: '',
  title: '',
  actionTitle: '확인',
  cancelTitle: '취소'
})

const buttonRef = ref(null)

const open = (param: ConfirmConfig) => {
  config.type = param.type ?? ''
  config.title = param.title ?? ''
  config.contents = param.contents
  config.actionTitle = param.actionTitle ?? '확인'
  config.cancelTitle = param.cancelTitle ?? '취소'
  config.action = param.action
  config.cancel = param.cancel

  isOpen.value = true

  const button: any = buttonRef.value
  button && button.$el.focus()
}

const close = () => {
  isOpen.value = false
}

const handleActionClick = () => {
  config.action && config.action()
  close()
}

const handleCancelClick = () => {
  config.cancel && config.cancel()
  close()
}

expose({ open, close })

return { __sfc: true,isOpen, config, buttonRef, open, close, handleActionClick, handleCancelClick, AlertLayout }
}

})